import { FC } from "react";

interface ArchiveBoxIconSVGProps {
    className?: string;
}

const ArchiveBoxIconSVG: FC<ArchiveBoxIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="30"
            height="26"
            viewBox="0 0 30 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.33366 7.66667V22.3333C4.33366 23.0406 4.61461 23.7189 5.11471 24.219C5.6148 24.719 6.29308 25 7.00033 25H23.0003C23.7076 25 24.3858 24.719 24.8859 24.219C25.386 23.7189 25.667 23.0406 25.667 22.3333V7.66667M12.3337 13H17.667M3.00033 1H27.0003C27.7367 1 28.3337 1.59695 28.3337 2.33333V6.33333C28.3337 7.06971 27.7367 7.66667 27.0003 7.66667H3.00033C2.26395 7.66667 1.66699 7.06971 1.66699 6.33333V2.33333C1.66699 1.59695 2.26395 1 3.00033 1Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ArchiveBoxIconSVG;
